import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  ConfirmPaymentDataIn,
  ServiceConnection,
} from 'src/app/models/serviceConnection.model';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { PermissionsService } from 'shared-lib';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-service-connection-details',
  templateUrl: './service-connection-details.component.html',
  styleUrls: ['./service-connection-details.component.scss'],
})
export class ServiceConnectionDetailsComponent implements OnInit {
  customer: ServiceConnection = new ServiceConnection();

  customerId = 0;

  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  contractNumber: string =
    this.translationService.getByKeyFromStorage('Contract number');

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    public permissionsService: PermissionsService,
    private translationService: TranslationService,
    private kycService: AccountKycService,
  ) {}

  ngOnInit(): void {
    const customerId = this.activatedRoute.snapshot.paramMap.get('detailsId');
    this.customerId = Number(customerId);
    this.getCustomer(customerId);
  }

  private getCustomer(customerId: any) {
    this.kycService.getServiceConnectionById(customerId).subscribe({
      next: (response) => {
        if (response?.status === 200 || response?.status === 'OK') {
          this.customer = new ServiceConnection(response.data);
        } else {
          this.toastr.error(response?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  confirmPayment() {
    const dataIn: ConfirmPaymentDataIn = {
      kycId: this.customer.id,
      verificationId: this.customer.siteVerificationId,
    };

    this.kycService.confirmPayment(dataIn).subscribe({
      next: (response) => {
        if (response?.status === 200 || response?.status === 'OK') {
          this.toastr.success(response?.message);
          window.location.reload();
        } else {
          this.toastr.error(response?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
}
